import React from 'react'
import Sidebar from "../Sidebar/Sidebar"

const Dashboard = () => {
    return (
        <div>
            <h1 className="whole">Seller Dashboard</h1>
            <hr className="hr-wish" />
            <Sidebar/>
            
        </div>
    )
}

export default Dashboard
